<div #stepper>
  <div class="line"></div>
  <div class="stepper">
    <dx-button *ngFor="let step of steps" [stylingMode]="'text'" [ngClass]="{ npButtonFocus: step.name === name, 'no-ripple': true }" [width]="buttonWidth" (onClick)="selectStage(step)">
      <div class="circle-wrapper">
        <div class="circle">
          <div class="inner">
            <i *ngIf="step.icon" [ngStyle]="{ fontSize: '4ch' }" class="dx-icon-{{ step.icon }}"></i>
          </div>
        </div>
      </div>
      <div class="text">{{ step.name | translate }}</div>
    </dx-button>
  </div>
</div>
